import type { FaireProductEntity } from "../../entity_types/product";

export const p_mj6nj9adnd: FaireProductEntity = {
  token: "p_mj6nj9adnd",
  type: "product",
  name: "bunny with bow mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/eb528cf433e36445fae1f4aa6fe52693df58e2c08a78e116066654d425970e98.jpeg",
  galleryImageUrls: [],
  priceDollars: 2,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty presentation. \n\n\nDetails:\n\n- single card + envelope \n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n\n\n',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:49.790Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
